import i18n from "i18next";

export const progressColor = (progVal) => {
    const progress = parseInt(progVal)
    if (progress < 50)
        return "#D93630";  //RED
    else if (progress < 60)
        return "#FB810F";  //AMBER
    else if (progress < 80)
        return "#77B10B";  //GREEN
    else if (progress >= 80)
        return "#1D8734";  //DARKGREEN
    else
        return "#979797";  //GREY
}

export const metricProgressColor = {
    "#339933": i18n.t('Above Plan'),
    "#99cc66": i18n.t('On Plan'),
    "#ff9933": i18n.t('Medium Risk'),
    "#db3a1b": i18n.t('At Risk'),
    "#b7b7b7": i18n.t('Not Started'),
}

export const getRagOptions = () => {
    const orgColors = typeof wbConfig !== 'undefined' ? wbConfig?.orgColors?.rag_color?.colors : undefined;
    return Object.entries(metricProgressColor)
        .filter(([, label]) => label !== 'Not Started')
        .map(([defaultColor, label], idx) => ({
            label,
            value: String(idx + 1),
            color: orgColors?.[idx + 1] ?? defaultColor,
        }));
};
